import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.function.name";
import _objectSpread from "/data/jenkins/workspace/saas-prod_cp-fe-bms-web/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { resetStuPassword, resetTeaPassword, getAutoSid, getCommonUser, grantTrialHandle, getClassListByGrade, addNewStudent } from '@data/login';
import { getAppList } from '@data/user';
import { getSysDirectory as _getSysDirectory } from '@data/user';
import { getGradeClassList, updateStudentInfo, studentDetail } from '@data/student';
import { eidtTeacherNameById } from '@data/teacher';
import { mapActions, mapGetters } from 'vuex';
import { getToken, getSessionToken } from '@/utils/auth';
import env from '@/config/index';
export default {
  name: 'moreApply',
  data: function data() {
    var _this = this;

    var validateFn = function validateFn(rule, value, callback) {
      if (value === '' && _this.classList.length == 0) {
        callback(new Error('该年级下的班级没有进行中的测评！'));
      } else {
        callback();
      }
    };
    /* 手机号验证 */


    var verifyPhoneNum = function verifyPhoneNum(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入您的手机号码'));
      } else if (!_this.tools.phoneVerify(value)) {
        callback(new Error('请输入正确的手机号码!'));
      } else {
        callback();
      }
    };

    return {
      isShowSetting: false,
      // 右侧工具箱是否显示
      isShowHaveSidItem: true,
      // 是否展示有学籍号label
      showAddDialog: false,
      // 添加学生dialog
      showSearchDialog: false,
      // 查询diaolog
      showTeacherDialog: false,
      // 教师信息修改dialog
      busId: '',
      // 当前登录用户的busid
      tableDataList: [],
      setTeacherParams: {
        search: '',
        pageNo: 1,
        pageSize: 10
      },
      setTeacherTotal: 0,
      title: '注册并授权单个学生',
      studentInfoForm: {
        gradeId: '',
        // 年级id
        classId: '',
        // 班级id
        gradeName: '',
        className: '',
        name: '',
        // 名称
        isHaveSid: 1,
        // 是否有学籍号
        sid: '',
        // 学籍号
        sex: '',
        // 性别
        nation: '1',
        // 民族
        itemName: '',
        // 民族名称
        isOnlyChild: '',
        // 是否独生子女
        isResidence: '' // 是否住校

      },
      formInline: {
        gradeId: [{
          required: true,
          message: '年级不能为空！',
          trigger: 'change'
        }],
        classId: [{
          validator: validateFn,
          trigger: 'change'
        }, {
          required: true,
          message: '班级不能为空！',
          trigger: 'change'
        }],
        name: [{
          required: true,
          message: '姓名不能为空！',
          trigger: 'blur'
        }, {
          pattern: /^[\S]{2,50}$/,
          message: '姓名输入在2~50个字！'
        }],
        nation: [{
          required: true,
          message: '民族不能为空！',
          trigger: 'change'
        }],
        sex: [{
          required: true,
          message: '性别不能为空！',
          trigger: 'change'
        }],
        sid: [{
          required: true,
          message: '学籍号不能为空!',
          trigger: 'blur'
        }, {
          pattern: /(^(A|a)[A-z]{3}$)|(^(G|L|J)[0-9A-z]{15}$)|(^(G|L|J)[0-9A-z]{18}$)/,
          message: '首字符必须是G或L或J,字母或数字长度为16位或19位!'
        }],
        isOnlyChild: [{
          required: true,
          message: '是否独生子女不能为空！',
          trigger: 'change'
        }],
        isResidence: [{
          required: true,
          message: '是否住校不能为空！',
          trigger: 'change'
        }],
        isHaveSid: [{
          required: true,
          message: '是否有学籍号不能为空！',
          trigger: 'change'
        }]
      },
      gradeList: [],
      classList: [],
      operat: '1',
      directoryData: [],
      editTeacherForm: {
        teacherId: '',
        name: '',
        phone: '' // isManager: ''

      },
      // 教师信息
      formRules: {
        name: [{
          required: true,
          trigger: 'blur',
          message: '请输入姓名！'
        }, {
          pattern: /^[\S]{2,50}$/,
          message: '姓名输入在2~50个字！'
        }],
        phone: {
          required: true,
          trigger: 'blur',
          validator: verifyPhoneNum
        } // isManager: {required: true, trigger: 'change', message: '请选择是否任教!'}

      },
      userType: null,
      type: null,
      moreList: [],
      isShowMore: false
    };
  },
  mounted: function mounted() {
    // 判断是否展示测评负责人右下角工具箱
    var userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.userType = userInfo && userInfo.type;
    this.busId = userInfo && userInfo.busId;
    var appList = userInfo && userInfo.appList;

    for (var i = 0, len = appList.length; i < len; i++) {
      if (appList[i].appCode == 'emes') {
        for (var j = 0, lens = appList[i].roleTypes.length; j < lens; j++) {
          if (appList[i].roleTypes[j].roleType == '14') {
            // this.busId = appList[i].roleTypes[j].orgBusInfoList[0].busId;
            this.isShowSetting = true;
            break;
          } else {
            this.isShowSetting = false;
          }
        }

        break;
      } else {
        this.isShowSetting = false;
      }
    }

    this.getGrade();
    this.getSysDirectory();
    this.getList();
  },
  watch: {
    'setTeacherParams.search': {
      handler: function handler(val) {
        if (val == '') {
          this.tableDataList = [];
        }
      },
      deep: true
    }
  },
  computed: _objectSpread({}, mapGetters('user', {
    userAlert: 'userAlerts'
  })),
  methods: _objectSpread({
    // 教师修改dialog
    teacherEditDialog: function teacherEditDialog(item) {
      this.editTeacherForm.teacherId = item.id;
      this.editTeacherForm.name = item.name;
      this.editTeacherForm.phone = item.account;
      this.editTeacherForm.isManager = '1';
      this.showTeacherDialog = true;
    },
    // 教师信息关闭dialog
    closeTeacherHandle: function closeTeacherHandle() {
      this.showTeacherDialog = false;
    },
    // 教师信息修改保存
    saveTeacherInfo: function saveTeacherInfo() {
      var _this2 = this;

      this.$refs.editTeacherForm.validate(function (valid) {
        if (valid) {
          eidtTeacherNameById(_this2.editTeacherForm).then(function (res) {
            _this2.setUserAlert({
              flag: true,
              type: 'success',
              text: _this2.msg.WARNING_86 || res.message
            });
          }).catch(function () {});
        }
      });
    },
    // 学生/教师查询dialog
    showSearchStuDialog: function showSearchStuDialog() {
      this.showSearchDialog = true;
    },
    // 关闭查询学生dialog的回调
    closeSearchHandle: function closeSearchHandle() {
      this.setTeacherParams.search = '';
    },
    // 查询学生列表
    getStudentList: function getStudentList() {
      var _this3 = this;

      var _that = this;

      if (this.setTeacherParams.search !== '') {
        getCommonUser({
          key: this.setTeacherParams.search
        }).then(function (res) {
          _this3.tableDataList = res;
        }).catch(function (resp) {
          _that.setUserAlert({
            flag: true,
            type: 'error',
            text: resp.message
          });
        });
      }
    },
    // 授权操作
    grantTrial: function grantTrial(item) {
      var _this4 = this;

      var _that = this;

      grantTrialHandle({
        roleType: item.roleType,
        busId: item.id,
        classId: item.orgId,
        orgCode: this.tools.getLocalStorage('userRole').orgCode
      }).then(function (res) {
        _this4.setUserAlert({
          flag: true,
          type: 'success',
          text: '授权成功!' || res.message
        });
      }).catch(function (resp) {
        _that.setUserAlert({
          flag: true,
          type: 'error',
          text: resp.message || '授权失败!'
        });
      });
    },
    // 编辑操作
    editHandle: function editHandle(item) {
      var _this5 = this;

      this.title = '编辑';
      this.showSearchDialog = false;
      this.isShowHaveSidItem = false; // 编辑状态不需要展示是否有学籍号label

      if (item.roleType == 7 || item.roleType == 9) {
        this.teacherEditDialog(item);
      } else {
        studentDetail({
          id: item.id
        }).then(function (res) {
          _this5.studentInfoForm = res;
          _this5.studentInfoForm.itemName = _this5.directoryData.filter(function (ele) {
            return ele.value == _this5.studentInfoForm.nation;
          })[0].itemName;

          _this5.getClassListByEdit(_this5.studentInfoForm.gradeId);

          _this5.showAddDialog = true;
        }).catch(function (resp) {
          _this5.setUserAlert({
            flag: true,
            type: 'error',
            text: resp.message
          });
        });
      }
    },
    // eslint-disable-next-line no-unused-vars
    getRowClass: function getRowClass(_ref) {
      var rowIndex = _ref.rowIndex;

      if (rowIndex == 0) {
        return 'background:#fafbfe';
      } else {
        return '';
      }
    },
    // 添加学生操作
    addStudent: function addStudent() {
      this.isShowHaveSidItem = true;
      this.showAddDialog = true;

      for (var key in this.studentInfoForm) {
        if (key == 'isHaveSid') {
          this.studentInfoForm[key] = 1;
        } else if (key == 'nation') {
          this.studentInfoForm[key] = '1';
        } else {
          this.studentInfoForm[key] = '';
        }
      }
    },
    // 关闭添加学生dialog的回调
    closeHandle: function closeHandle() {
      this.operat = 1;
      this.title = '注册并授权单个学生';
      this.$refs.studentInfoForm.resetFields();
      this.showAddDialog = false;
    },
    //  生成临时学籍号
    randomString: function randomString() {
      var _this6 = this;

      getAutoSid().then(function (res) {
        _this6.studentInfoForm.sid = res;
      }).catch(function (resp) {
        _this6.setUserAlert({
          flag: true,
          type: 'error',
          text: resp.message || '生成失败!'
        });
      });
    },
    // 编辑时获取班级列表
    getClassListByEdit: function getClassListByEdit(id) {
      this.classList = this.gradeList.filter(function (ele) {
        return ele.id == id;
      })[0].schoolClassList;
      this.classList.forEach(function (ele) {
        return ele.busId = ele.id;
      });
    },
    // 年级切换获取classlist
    getCurClass: function getCurClass(gradeId, classId) {
      var _this7 = this;

      this.studentInfoForm.gradeName = this.gradeList.filter(function (ele) {
        return ele.id == _this7.studentInfoForm.gradeId;
      })[0].name;
      this.studentInfoForm.classId = '';

      var _that = this;

      getClassListByGrade({
        busId: this.busId
      }, this.studentInfoForm.gradeId).then(function (res) {
        if (res && res.length > 0) {
          _this7.classList = res;
          _this7.studentInfoForm.classId = classId || res[0].busId;
          _this7.studentInfoForm.className = _this7.classList.filter(function (ele) {
            return ele.busId == _this7.studentInfoForm.classId;
          })[0].name;

          if (res.length == 0) {
            _this7.$refs.studentInfoForm.validateField('classId', function (err) {
              console.log(err);
            });
          }
        }
      }).catch(function (resp) {
        _that.setUserAlert({
          flag: true,
          type: 'error',
          text: resp.message
        });
      });
    },
    // 班级选择
    changeClass: function changeClass() {
      var _this8 = this;

      this.studentInfoForm.className = this.classList.filter(function (ele) {
        return ele.busId == _this8.studentInfoForm.classId;
      })[0].name;
    },
    // 是否有学籍号切换
    changeIsHaveSid: function changeIsHaveSid(val) {
      this.studentInfoForm.sid = '';

      if (val == 0) {
        this.$refs['replaceSid'].clearValidate();
        this.randomString();
      }
    },
    // 切换民族
    changeNation: function changeNation(val) {
      this.studentInfoForm.itemName = this.directoryData.filter(function (ele) {
        return ele.value == val;
      })[0].itemName;
    },
    // 获取年级信息
    getGrade: function getGrade() {
      var _this9 = this;

      var _that = this;

      getGradeClassList().then(function (res) {
        _this9.gradeList = res;
      }).catch(function (resp) {
        _that.setUserAlert({
          flag: true,
          type: 'error',
          text: resp.message
        });
      });
    },
    // 获取民族字典信息
    getSysDirectory: function getSysDirectory() {
      var _this10 = this;

      var _that = this;

      _getSysDirectory({
        codes: 'DC0008'
      }).then(function (res) {
        _this10.directoryData = res.DC0008;
      }).catch(function (resp) {
        _that.setUserAlert({
          flag: true,
          type: 'error',
          text: resp.message
        });
      });
    },
    checkForm: function checkForm() {
      var _this11 = this;

      this.$refs.studentInfoForm.validate(function (valid) {
        if (valid) {
          _this11.operat = 3;
          _this11.title = '确认注册信息';
        }
      });
    },
    // 返回修改编辑
    toBackEdit: function toBackEdit() {
      this.operat = 1;
      this.title = '注册并授权单个学生';
    },
    // 添加学生操作
    addStudentHandle: function addStudentHandle() {
      var _this12 = this;

      var _that = this;

      if (this.operat == 3) {
        if (this.studentInfoForm.id) {
          updateStudentInfo(this.studentInfoForm).then(function () {
            _that.setUserAlert({
              flag: true,
              type: 'success',
              text: _this12.msg.WARNING_86 || '更新成功！'
            });

            _this12.showAddDialog = false;
          }).catch(function (resp) {
            _that.setUserAlert({
              flag: true,
              type: 'error',
              text: resp.message || '操作失败！'
            });
          });
        } else {
          addNewStudent(this.studentInfoForm).then(function () {
            _that.setUserAlert({
              flag: true,
              type: 'success',
              text: _this12.msg.WARNING_86 || '新增学生信息成功!'
            });

            _this12.showAddDialog = false;
          }).catch(function (resp) {
            _that.setUserAlert({
              flag: true,
              type: 'error',
              text: resp.message || '操作失败！'
            });
          });
        }
      }
    },
    // 重置密码
    resetPwd: function resetPwd(item) {
      var _that = this;

      this.$confirm('确定要重置密码么？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        if (item.roleType == '5') {
          resetStuPassword({
            ids: item.id
          }).then(function (resp) {
            _that.setUserAlert({
              flag: true,
              type: 'success',
              text: '密码重置成功!' || resp.message
            });
          }).catch(function (resp) {
            _that.setUserAlert({
              flag: true,
              type: 'error',
              text: resp.message || '操作失败！'
            });
          });
        } else {
          resetTeaPassword({
            ids: item.id
          }).then(function (resp) {
            _that.setUserAlert({
              flag: true,
              type: 'success',
              text: '密码重置成功!' || resp.message
            });
          }).catch(function (resp) {
            _that.setUserAlert({
              flag: true,
              type: 'error',
              text: resp.message || '操作失败！'
            });
          });
        }
      }).catch(function () {});
    }
  }, mapActions('user', {
    setUserAlert: 'setUserAlert'
  }), {
    getList: function getList() {
      var _this13 = this;

      var _that = this;

      getAppList().then(function (resp) {
        _that.moreList = resp.filter(function (ele) {
          return ele.code.toLowerCase() != 'bms';
        });
      }).catch(function (resp) {
        _this13.setUserAlert({
          flag: true,
          type: 'error',
          text: resp.message
        });
      });
    },
    listFn: function listFn(item) {
      var token = getToken() || getSessionToken();

      if (item.code.toLowerCase() === 'bms') {
        var flag = this.tools.getLocalStorage('userInfo').flag;

        if (flag) {
          window.location.href = "".concat(item.url, "#/updatePwd");
        } else {
          window.location.href = item.url;
        }
      } else if (item.code.toLowerCase() === 'mces') {
        window.location.href = "".concat(env.mcesUrl, "choseRole?token=").concat(token);
      } else if (item.code.toLowerCase() === 'emes') {
        window.location.href = "".concat(env.emesUrl, "/#/roleList?token=").concat(token);
      } else if (item.code.toLowerCase() === 'sycp') {
        window.location.href = "".concat(env.sycpUrl, "/#/?token=").concat(token);
      } else if (item.code.toLowerCase() === 'ei') {
        window.location.href = "".concat(env.eiUrl, "/blank?token=").concat(token);
      }
    },
    moreFitler: function moreFitler(code) {
      var str = '';

      if (code.toLowerCase() === 'emes') {
        str = '教育评价';
      } else if (code.toLowerCase() === 'bms') {
        str = '用户管理';
      } else if (code.toLowerCase() === 'mces') {
        str = '初中综评';
      } else if (code.toLowerCase() === 'sycp') {
        str = '学科素养测评';
      } else if (code.toLowerCase() === 'ei') {
        str = '测评报告';
      }

      return str;
    },
    showMore: function showMore() {
      if (!(this.userType == 6 || this.userType == 5)) {
        this.isShowMore = !this.isShowMore;
      }
    }
  })
};